// src/client/game/core/types.ts

export type GridPos = {
  x: number;
  y: number;
};

export type Direction = {
  dx: number;
  dy: number;
};

export enum FoodKind {
  Normal = "normal",
  Gold = "gold",
  Blue = "blue",
  Laser = "laser",
  Star = "star",
  Icy = "icy",
}

export interface FoodDefinition {
  id: FoodKind;
  label: string;
  color: number; // 0xRRGGBB
  apply(model: import("./GameModel").GameModel): void;
}

export interface FoodInstance {
  id: FoodKind;
  x: number;
  y: number;
}

/**
 * Extra powers that can hook into the model.
 * For now we only use fire() for the laser.
 */
export interface Ability {
  id: string;
  fire?(model: import("./GameModel").GameModel): void;
}

/** Stats for a completed run (submitted to server). */
export type RunStats = {
  score: number;
  timeMs: number;
  laserLevel: number;
};
